import { OnOffSwitch } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";

import { StyledOverviewCell, StyledOverviewActions } from "../styles";

import type { OverwriteCellPropsType } from "./types";

export const OverwriteCell = ({ onClick, overwrite, isRequired, setting, tooltipContent }: OverwriteCellPropsType) => {
    const handleClick = () => onClick(setting, !overwrite);

    return (
        <StyledOverviewCell>
            {!isRequired ? <PlainTooltip tooltipContent={tooltipContent}>
                    <StyledOverviewActions>
                        <OnOffSwitch
                            onClick={handleClick}
                            isSelected={overwrite}
                        />
                    </StyledOverviewActions>
                </PlainTooltip> : null}
        </StyledOverviewCell>
    );
};
